import ee from 'event-emitter'

const bridge = ee()

/**
 * Private event emitter used to handle communication
 * with the 8x8-meet module.
 */
export default bridge
